import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Loader2 } from 'lucide-react';
import { ProfileFormData } from './types';

interface ProfileTabProps {
  profileForm: ProfileFormData;
  loadingProfile: boolean;
  savingProfile: boolean;
  onProfileChange: (field: keyof ProfileFormData, value: string) => void;
  onSaveProfile: () => void;
}

export function ProfileTab({
  profileForm,
  loadingProfile,
  savingProfile,
  onProfileChange,
  onSaveProfile,
}: ProfileTabProps) {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Profile Information</CardTitle>
          <CardDescription>
            Update your personal information and contact details.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {loadingProfile ? (
            <div className="flex items-center justify-center py-4">
              <Loader2 className="h-6 w-6 animate-spin mr-2" />
              <span>Loading profile...</span>
            </div>
          ) : (
            <>
              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label htmlFor="firstName">First Name</Label>
                  <Input
                    id="firstName"
                    placeholder=""
                    value={profileForm.firstName}
                    onChange={(e) => onProfileChange('firstName', e.target.value)}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="lastName">Last Name</Label>
                  <Input
                    id="lastName"
                    placeholder=""
                    value={profileForm.lastName}
                    onChange={(e) => onProfileChange('lastName', e.target.value)}
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder=""
                  value={profileForm.email}
                  onChange={(e) => onProfileChange('email', e.target.value)}
                  disabled
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  id="phone"
                  type="tel"
                  placeholder=""
                  value={profileForm.phone}
                  onChange={(e) => onProfileChange('phone', e.target.value)}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="jobTitle">Job Title</Label>
                <Input
                  id="jobTitle"
                  placeholder=""
                  value={profileForm.jobTitle}
                  onChange={(e) => onProfileChange('jobTitle', e.target.value)}
                />
              </div>
              <Button onClick={onSaveProfile} disabled={savingProfile}>
                {savingProfile ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin mr-2" />
                    Saving...
                  </>
                ) : (
                  'Save Changes'
                )}
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
